export default __webpack_public_path__ + "static/media/line-green.a58f3a61.svg";